import { ValidationErrors, ValidatorFn, AbstractControl, FormGroup } from "@angular/forms";

export class PasswordValidator {

  static patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }
      // test the value of the control against the regexp supplied
      const valid = regex.test(control.value);
      // if true, return no error (no error), else return error passed in the second parameter
      return valid ? null : error;
    };
  }


  static passwordsMatch(g: FormGroup): { [s: string]: boolean } {
    let p1 = g.controls['newPassword'].value == null ? "" : g.controls['newPassword'].value;
    let p2 = g.controls['repeatNewPassword'].value == null ? "" : g.controls['repeatNewPassword'].value;

    let c1 = g.controls['newPassword'];
    let c2 = g.controls['repeatNewPassword'];

    if (p1 != p2 && p1 != "" && p2 != "") {
      c1.setErrors({ 'passwordsMatch': true })
      c2.setErrors({ 'passwordsMatch': true })

      return { 'passwordsMatch': true };
    }
    else {
      if (p1 != "" && !c1.hasError('required') && !c1.hasError('minlength')) { c1.setErrors(null); }
      if (p2 != "" && !c2.hasError('required') && !c2.hasError('minlength')) { c2.setErrors(null); }
    }

    return null;
  }


  //static passwordMatchValidator(control: AbstractControl) {
  //  const newPassword: string = control.get('newPassword').value; // get password from our password form control
  //  const confirmPassword: string = control.get('confirmPassword').value; // get password from our confirmPassword form control
  //  // compare is the password math
  //  if (newPassword !== confirmPassword) {
  //    // if they don't match, set an error in our confirmPassword form control
  //    control.get('confirmPassword').setErrors({ NoPassswordMatch: true });
  //  }
  //}


}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/custom/password-validator.ts